import { GET_LOGS_API_URL } from "../OpticApiConfig";
import axios from 'axios';

export const LoadingLogs = async (setLogs, showSnackbar) => {
    try {
      const token = localStorage.getItem('token');
      const resultLog = await axios.get(`${GET_LOGS_API_URL}`,{
        headers:{
            'Authorization': `Bearer ${token}` 
          }
    });
      setLogs(resultLog.data);
    } catch (error) {
      showSnackbar('Ошибка при получении логов', 'snackbarError');
    }
  };